<mat-form-field *ngIf='!loading' fxFlex class='mt-8' color='primary' appearance="fill">
    <mat-label>Selected Warehouse</mat-label>
    <mat-select (ngModelChange)='changeWarehouse($event)' [(ngModel)]='selectedWarehouse' [compareWith]="compareWith">
        <mat-option [value]="warehouse" *ngFor="let warehouse of warehouses">{{ warehouse.name }}</mat-option>
    </mat-select>
</mat-form-field>